module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/icon-hotel-and-dinner-course-ecc158ca61ed2563b43fc91074a8abe7.svg";